import React, { useState } from "react";
import ProccessApp from "./Subprocess/ProccessApp";
import { getWfPhasesColor } from "../../services/appService";

const JourneySteps = (props) => {
  const [subProccessShowHide, setSubProccessShowHide] = useState(false);
  const [selectedSubProcessTask, setSelectedSubProcessTask] = useState(null);

  const {
    custApp,
    handleJorneySteps,
    candidateObj,
    journeyShowHide = true,
    selectedTaskId,
    selectedTaskItemId,
  } = props;

  const totalPhases = custApp?.allWfPhase
    ? custApp.allWfPhase.filter(
      (x) =>
        x.wfPhase !== "" &&
        x.wfPhase !== "Application" &&
        x.wfPhase !== "Rejected",
    )
    : [];

  const allTasks = custApp?.workflowTasks
    ? custApp.workflowTasks
      .filter(
        (x) =>
          x.itemType !== 3 &&
          x.itemType !== 2 &&
          x.itemType !== 5 &&
          x.itemType !== 4,
      )
      .sort((a, b) => a.orderNumber - b.orderNumber)
    : [];

  const handleProcessShowHide = (tsk) => {
    if (tsk) {
      setSelectedSubProcessTask(tsk);
      setSubProccessShowHide(true);
      return;
    }
    setSubProccessShowHide(false);
  };

  const getTaskLabel = (task) =>
    task.itemName === "Verify Insurance Expiry Date"
      ? "Verify Insurance"
      : task.itemName;

  const getWfPhaseStatusMeta = (phase) => {
    const pAll = allTasks.filter(
      (x) => x.wfPhase === phase && x.itemType === 1,
    );
    const dAll = allTasks.filter(
      (x) => x.wfPhase === phase && x.taskDoneStatus === 4 && x.itemType === 1,
    );
    const activeWithWiid = allTasks.filter(
      (x) =>
        x.wfPhase === phase &&
        x.taskDoneStatus === 2 &&
        x.wiid > 0 &&
        x.itemType === 1,
    );

    // DONE: all tasks in phase have taskDoneStatus === 4
    if (pAll.length > 0 && dAll.length === pAll.length) {
      return {
        icon: "fa-check",
        label: "DONE",
        status: "done",
      };
    }

    // IN PROGRESS: at least one task has wiid > 0 AND taskDoneStatus === 2
    if (activeWithWiid.length > 0) {
      return {
        icon: "fa-cog",
        label: "IN PROGRESS",
        status: "active",
      };
    }

    // PENDING: all tasks have taskDoneStatus === 0 (or no active/done tasks)
    return {
      icon: "fa-hourglass-o",
      label: "PENDING",
      status: "pending",
    };
  };

  return (
    <div className={`journey-sidebar-rich ${!journeyShowHide ? "collapsed" : ""}`}>
      <style>{`
        .journey-sidebar-rich {
          width: 100%;
          color: #1e293b;
          font-family: "Inter", "Segoe UI", Roboto, sans-serif;
          transition: all 0.3s ease;
          padding: 12px 14px;
        }
        .journey-sidebar-rich * { box-sizing: border-box; }
        
        .journey-timeline {
          position: relative;
          padding: 0;
          list-style: none;
          margin: 0;
        }
        
        /* Phase Color Variables */
        .journey-phase-item.btn-primary { --phase-clr: #3b82f6; --phase-bg: #eff6ff; }
        .journey-phase-item.btn-info { --phase-clr: #06b6d4; --phase-bg: #ecfeff; }
        .journey-phase-item.btn-warning { --phase-clr: #f39a27; --phase-bg: #fef5e9; }
        .journey-phase-item.btn-success { --phase-clr: #2dce89; --phase-bg: #e8f9f1; }
        .journey-phase-item.btn-wf2-default { --phase-clr: #ffd600; --phase-bg: #fffde7; }
        .journey-phase-item.btn-wf3-default { --phase-clr: #2dce89; --phase-bg: #e8f9f1; }
        .journey-phase-item.btn-wf4-default { --phase-clr: #f5365c; --phase-bg: #fde8ec; }
        .journey-phase-item.btn-wf5-default { --phase-clr: #e749a0; --phase-bg: #fcebf4; }
        .journey-phase-item.btn-wf6-default { --phase-clr: #c7a3ff; --phase-bg: #f5eeff; }
        .journey-phase-item.btn-wf7-default { --phase-clr: #f39a27; --phase-bg: #fef5e9; }
        .journey-phase-item.btn-wf8-default { --phase-clr: #6dc8e5; --phase-bg: #f0f9fc; }
        .journey-phase-item.btn-wf9-default { --phase-clr: #5e3134; --phase-bg: #efeaeb; }
        .journey-phase-item.btn-default { --phase-clr: #64748b; --phase-bg: #f8fafc; }

        /* Vertical Timeline Connecting Line */
        .journey-phase-item::before {
          content: "";
          position: absolute;
          top: 20px;
          bottom: -22px;
          left: 20px;
          width: 1.5px;
          background: var(--phase-clr, #cbd5e1);
          z-index: 1;
          transition: all 0.3s ease;
        }

        .journey-phase-item.pending::before {
          background: #cbd5e1 !important;
        }

        .journey-phase-item:last-child::before {
          display: none !important;
        }

        .journey-sidebar-rich.collapsed .journey-phase-item::before {
          display: none !important;
        }

        .journey-phase-item {
          position: relative;
          margin-bottom: 16px;
          z-index: 2;
          padding: 0;
          border-radius: 8px;
          transition: all 0.3s ease;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        /* Header Container */
        .journey-phase-header {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          padding: 2px 12px 2px 2px;
          border-radius: 8px;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          background: #ffffff;
          border: 1px solid var(--phase-clr, #cbd5e1);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
          position: relative;
          z-index: 2;
        }

        .journey-phase-header:hover {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.05);
        }

        .journey-sidebar-rich.collapsed .journey-phase-header {
          justify-content: center;
          padding: 0;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        /* Phase Icon */
        .journey-phase-icon {
          width: 36px;
          height: 36px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-shrink: 0;
          z-index: 2;
          transition: all 0.3s ease;
        }

        .journey-phase-icon.solid-icon {
          background: var(--phase-clr) !important;
          color: #ffffff !important;
          border: none !important;
        }

        .journey-phase-icon.pale-icon {
          background: var(--phase-bg) !important;
          color: #ffffff !important;
          border: none !important;
        }

        .journey-phase-icon.pending-icon {
          background: var(--phase-clr, #f8fafc) !important;
          color: #f8fafc !important;
          border: 1px solid var(--phase-clr, #cbd5e1) !important;
        }

        .journey-sidebar-rich.collapsed .journey-phase-icon {
          width: 32px;
          height: 32px;
          font-size: 13px;
        }

        .journey-phase-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-width: 0;
          flex: 1;
          gap: 10px;
        }

        .journey-sidebar-rich.collapsed .journey-phase-info {
          display: none;
        }

        .journey-phase-name {
          font-size: 12.5px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          white-space: nowrap;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .journey-phase-status-badge {
          display: inline-flex;
          align-items: center;
          font-size: 10.5px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          width: fit-content;
        }
        .journey-phase-status-badge.active { color: #1e293b; }
        .journey-phase-status-badge.done { color: #1e293b; }
        .journey-phase-status-badge.pending { color: #94a3b8; }

        /* Task Cards Layout */
        .journey-tasks {
          margin-left: 36px;
          display: flex;
          flex-direction: column;
          gap: 5px;
          margin-top: 8px;
          margin-bottom: 8px;
          padding-right: 0px;
        }

        .journey-sidebar-rich.collapsed .journey-tasks {
          display: none;
        }

        .journey-task-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 12px;
          border-radius: 6px;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease;
          cursor: pointer;
          position: relative;
          box-shadow: none !important;
        }

        .journey-task-row:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
        }

        .journey-task-row.disabled-task {
          cursor: default;
          pointer-events: none;
        }

        .journey-task-row.disabled-task .journey-task-text {
          color: #1e293b !important;
        }

        .journey-task-indicator {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 10px;
          transition: all 0.2s ease;
        }

        .journey-task-indicator.active-indicator {
          background: #f1f5f9 !important;
          border: 1px solid #94a3b8 !important;
          color: #64748b !important;
        }

        .journey-task-indicator.selected-indicator {
          background: var(--phase-bg, #fffde7) !important;
          border: 1px solid var(--phase-clr, #ffd600) !important;
          color: var(--phase-clr, #d97706) !important;
        }

        .journey-task-indicator.done-indicator {
          background: #22c55e !important;
          border: none !important;
          color: #ffffff !important;
        }

        .journey-task-indicator.pending-indicator {
          background: transparent !important;
          border: 1.5px solid #cbd5e1 !important;
        }

        .journey-task-text {
          font-size: 12.5px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #3b82f6;
          transition: color 0.2s ease;
        }

        .journey-task-row.selected {
          background: var(--phase-bg, #fffde7) !important;
          border-color: var(--phase-clr, #ffd600) !important;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08) !important;
        }

        .journey-task-row.selected .journey-task-text {
          color: #0f172a !important;
          font-weight: 700 !important;
        }
        
        /* Subprocess Section Styling */
        .journey-subprocess-group {
          margin-top: 6px;
          margin-bottom: 6px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .journey-sidebar-rich.collapsed .journey-subprocess-group {
          display: none;
        }

        .journey-subprocess-header {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 10.5px;
          font-weight: 600;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 2px;
          padding-left: 2px;
        }

        .journey-subprocess-icon {
          font-size: 11px;
          color: #1e293b;
        }

        .journey-task-row.subprocess {
          padding: 8px 12px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          align-items: flex-start !important;
          gap: 4px;
          cursor: pointer;
          width: 100%;
        }

        .journey-task-row.subprocess:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
        }

        .journey-subprocess-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        .journey-subprocess-title {
          font-size: 12.5px;
          font-weight: 500;
          color: #3b82f6;
        }

        .journey-subprocess-open {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 5px;
          color: #1e293b;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          flex-shrink: 0;
          font-size: 11px;
        }

        .journey-subprocess-bottom {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 5px;
          font-size: 10.5px;
          font-weight: 600;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          width: 100%;
          text-align: left;
        }

        .journey-subprocess-bullet {
          font-size: 14px;
          line-height: 1;
        }

        /* Skeleton Styles */
        @keyframes skeleton-pulse {
          0% { background-color: #f1f5f9; }
          50% { background-color: #cbd5e1; }
          100% { background-color: #f1f5f9; }
        }

        .journey-skeleton-pulse {
          animation: skeleton-pulse 1.8s infinite ease-in-out;
        }

        .journey-skeleton-item {
          position: relative;
          margin-bottom: 24px;
          padding: 0;
          z-index: 2;
        }

        .journey-skeleton-item::before {
          content: "";
          position: absolute;
          top: 26px;
          bottom: -32px;
          left: 26px;
          width: 2px;
          background: #cbd5e1;
          z-index: 1;
        }

        .journey-skeleton-item:last-child::before {
          display: none !important;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-item::before {
          display: none !important;
        }

        .journey-skeleton-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 4px 16px 4px 4px;
          border-radius: 9999px;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          position: relative;
          z-index: 2;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-header {
          justify-content: center;
          padding: 0;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        .journey-skeleton-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-icon {
          width: 38px;
          height: 38px;
        }

        .journey-skeleton-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-width: 0;
          flex: 1;
          gap: 12px;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-info {
          display: none;
        }

        .journey-skeleton-name {
          height: 12px;
          width: 45%;
          border-radius: 4px;
        }

        .journey-skeleton-badge {
          height: 16px;
          width: 50px;
          border-radius: 6px;
        }

        .journey-skeleton-tasks {
          margin-left: 48px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 12px;
          padding-right: 4px;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-tasks {
          display: none;
        }

        .journey-skeleton-task-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 16px;
          border-radius: 14px;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          opacity: 0.65;
        }

        .journey-skeleton-task-indicator {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .journey-skeleton-task-text {
          height: 10px;
          width: 60%;
          border-radius: 3px;
        }

        /* Empty State Styles */
        .journey-empty-state {
          text-align: center;
          border: 2px dashed #e2e8f0;
          border-radius: 16px;
          padding: 24px 16px;
          background: #f8fafc;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          list-style: none;
        }

        .journey-empty-icon {
          color: #94a3b8;
          margin-bottom: 12px;
          transition: all 0.3s ease;
        }

        .journey-empty-title {
          font-size: 13px;
          font-weight: 650;
          color: #475569;
          margin: 0 0 6px 0;
        }

        .journey-empty-desc {
          font-size: 11px;
          color: #64748b;
          margin: 0;
          line-height: 1.4;
        }

        .journey-sidebar-rich.collapsed .journey-empty-state {
          border: none;
          background: transparent;
          padding: 12px 0;
        }

        .journey-sidebar-rich.collapsed .journey-empty-icon {
          font-size: 20px;
          margin-bottom: 0;
        }

        .journey-sidebar-rich.collapsed .journey-empty-info {
          display: none;
        }
      `}</style>

      <ul className="journey-timeline">
        {!custApp ? (
          <>
            {/* Skeleton Item 1: Header + 2 Tasks */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
              <div className="journey-skeleton-tasks">
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
              </div>
            </li>
            {/* Skeleton Item 2: Header + 1 Task */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
              <div className="journey-skeleton-tasks">
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
              </div>
            </li>
            {/* Skeleton Item 3: Header Only */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
            </li>
          </>
        ) : totalPhases.length === 0 ? (
          <li className="journey-empty-state">
            <i className="fa fa-folder-open-o journey-empty-icon" style={{ fontSize: "28px" }} aria-hidden="true"></i>
            <div className="journey-empty-info">
              <h5 className="journey-empty-title">No Phases Found</h5>
              <p className="journey-empty-desc">There are no workflow phases defined for this journey.</p>
            </div>
          </li>
        ) : (
          totalPhases.map((item, key) => {
            const phaseMeta = getWfPhaseStatusMeta(item.wfPhase);
            const phaseColorClass = getWfPhasesColor(item.wfPhase);
            const phaseTasks = allTasks.filter((x) => x.wfPhase === item.wfPhase);

            const iconClass = (phaseMeta.status === "done" || phaseMeta.status === "active")
              ? "solid-icon"
              : "pending-icon";

            const orderedPhaseBlocks = phaseTasks.reduce((blocks, task) => {
              if (task.itemType === 14) {
                const lastBlock = blocks[blocks.length - 1];
                if (lastBlock?.type === "subprocess") {
                  lastBlock.tasks.push(task);
                } else {
                  blocks.push({ type: "subprocess", tasks: [task] });
                }
                return blocks;
              }

              if (task.itemType === 1) {
                blocks.push({ type: "task", task });
              }

              return blocks;
            }, []);

            return (
              <li key={item.wfPhase || key} className={`journey-phase-item ${phaseMeta.status} ${phaseColorClass}`}>
                <div className="journey-phase-header" onClick={() => phaseMeta.status !== "pending" && handleJorneySteps(allTasks.find(x => x.wfPhase === item.wfPhase)?.wiid)}>
                  <div className={`journey-phase-icon ${iconClass}`}>
                    <i className={`fa ${phaseMeta.icon}`} aria-hidden="true"></i>
                  </div>
                  <div className="journey-phase-info">
                    <h5 className="journey-phase-name">{item.wfPhase}</h5>
                    <span className={`journey-phase-status-badge ${phaseMeta.status}`}>
                      {phaseMeta.label}
                    </span>
                  </div>
                </div>

                <div className="journey-tasks">
                  {orderedPhaseBlocks.map((block, blockIndex) => {
                    if (block.type === "subprocess") {
                      return (
                        <div className="journey-subprocess-group" key={`subprocess-${item.wfPhase}-${blockIndex}`}>
                          <div className="journey-subprocess-header">
                            <i className="fa fa-sitemap journey-subprocess-icon" aria-hidden="true"></i>
                            <span>SUBPROCESS</span>
                          </div>
                          {block.tasks.map((task) => {
                            const isDone = task.taskDoneStatus === 4;
                            const isActive = task.taskDoneStatus === 2;
                            const isPending = task.taskDoneStatus === 0;
                            const statusLabel = isDone ? "COMPLETED" : isActive ? "IN PROGRESS" : "NOT AVAILABLE YET";

                            return (
                              <div
                                key={task.itemId || task.wiid || task.itemName}
                                className={`journey-task-row subprocess ${isDone ? "done" : ""} ${isActive ? "active" : ""} ${isPending ? "disabled" : ""}`}
                                onClick={() => task.taskDoneStatus > 0 && handleProcessShowHide(task)}
                                title={task.taskDoneStatus > 0 ? "Open subprocess details" : "Subprocess is not available yet"}
                              >
                                <div className="journey-subprocess-top">
                                  <span className="journey-subprocess-title" title={task.itemName}>{task.itemName}</span>
                                  <span className="journey-subprocess-open" aria-hidden="true">
                                    <i className="fa fa-external-link" />
                                  </span>
                                </div>
                                <div className="journey-subprocess-bottom">
                                  <span className="journey-subprocess-bullet">•</span>
                                  <span>{statusLabel}</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }

                    const task = block.task;
                    const taskLabel = getTaskLabel(task);
                    const isDone = task.taskDoneStatus === 4;
                    const isActive = task.taskDoneStatus === 2 && task.wiid > 0;
                    const hasWiid = task.wiid > 0;
                    const isClickable = hasWiid && (isDone || isActive);
                    const isSelected = selectedTaskItemId
                      ? String(task.itemId) === String(selectedTaskItemId)
                      : String(task.wiid) === String(selectedTaskId) && task.wiid > 0;
                    const isDarkText = isSelected || taskLabel === "Contract Management";

                    const indicatorClass = isDone
                      ? "done-indicator"
                      : isSelected
                        ? "selected-indicator"
                        : isActive
                          ? "active-indicator"
                          : "pending-indicator";

                    return (
                      <div
                        key={task.itemId || task.wiid || task.itemName}
                        className={`journey-task-row ${isDone ? "done" : ""} ${isSelected ? "selected" : ""} ${isDarkText ? "dark-text" : ""} ${!isClickable ? "disabled-task" : ""}`}
                        onClick={() => isClickable && handleJorneySteps(task.wiid)}
                      >
                        <div className={`journey-task-indicator ${indicatorClass}`}>
                          {isDone ? (
                            <i className="fa fa-check" />
                          ) : isSelected ? (
                            <i className="fa fa-dot-circle-o" />
                          ) : isActive ? (
                            <i className="fa fa-circle-o" />
                          ) : null}
                        </div>
                        <span className="journey-task-text">{taskLabel}</span>
                      </div>
                    );
                  })}
                </div>
              </li>
            );
          })
        )}
      </ul>
      {selectedSubProcessTask && (
        <ProccessApp
          processShowHide={subProccessShowHide}
          handleProcessShowHide={handleProcessShowHide}
          subProccessTask={selectedSubProcessTask}
          candidateObj={candidateObj}
        />
      )}
    </div>
  );
};

export default JourneySteps;

